// extracted by css-extract-rspack-plugin
export default {"levelsCardsRow":"levels-cards-row--CfRCAGThiwQ4QpNq","levelsCardTextContainer":"levels-card-text-container--EnTEEsC1pc4x7dej"};